import { useState } from 'react';

interface Props {
  onSubmit: (code: string) => void;
  onBack?: () => void;
  loading?: boolean;
  error?: string;
}

/**
 * Input OTP de 6 dígitos. Auto-avanza entre casillas, paste pega los 6
 * dígitos de una vez. Enter envía si los 6 están listos.
 */
export function TotpStep({ onSubmit, onBack, loading, error }: Props) {
  const [digits, setDigits] = useState<string[]>(['', '', '', '', '', '']);

  function update(i: number, v: string) {
    const ch = v.replace(/\D/g, '').slice(-1);
    const next = [...digits];
    next[i] = ch;
    setDigits(next);
    if (ch && i < 5) {
      const el = document.getElementById(`otp-${i + 1}`);
      el?.focus();
    }
    if (next.every((d) => d.length === 1)) {
      onSubmit(next.join(''));
    }
  }

  function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (text.length === 6) {
      e.preventDefault();
      const next = text.split('');
      setDigits(next);
      onSubmit(text);
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-center text-sm text-text-secondary">
        Ingresa el código de 6 dígitos de tu app de autenticación.
      </p>
      <div className="flex justify-center gap-2">
        {digits.map((d, i) => (
          <input
            key={i}
            id={`otp-${i}`}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={1}
            aria-label={`Dígito ${i + 1} de 6`}
            value={d}
            onChange={(e) => update(i, e.target.value)}
            onPaste={handlePaste}
            className="h-12 w-10 rounded-md border border-border bg-bg text-center text-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          />
        ))}
      </div>
      {error && (
        <p role="alert" className="rounded-md bg-destructive/10 p-2 text-sm text-destructive">
          {error}
        </p>
      )}
      <button
        type="button"
        onClick={onBack}
        disabled={loading}
        className="text-sm text-text-secondary hover:text-text-primary"
      >
        ← Volver
      </button>
    </div>
  );
}